var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const Svg4Contacts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.4 7.20039C3.2825 7.20039 4 6.48289 4 5.60039C4 4.71789 3.2825 4.00039 2.4 4.00039C1.5175 4.00039 0.8 4.71789 0.8 5.60039C0.8 6.48289 1.5175 7.20039 2.4 7.20039ZM13.6 7.20039C14.4825 7.20039 15.2 6.48289 15.2 5.60039C15.2 4.71789 14.4825 4.00039 13.6 4.00039C12.7175 4.00039 12 4.71789 12 5.60039C12 6.48289 12.7175 7.20039 13.6 7.20039ZM14.4 8.00039H12.8C12.36 8.00039 11.9625 8.17789 11.6725 8.46539C12.68 9.01789 13.395 10.0154 13.55 11.2004H15.2C15.6425 11.2004 16 10.8429 16 10.4004V9.60039C16 8.71789 15.2825 8.00039 14.4 8.00039ZM8 8.00039C9.5475 8.00039 10.8 6.74789 10.8 5.20039C10.8 3.65289 9.5475 2.40039 8 2.40039C6.4525 2.40039 5.2 3.65289 5.2 5.20039C5.2 6.74789 6.4525 8.00039 8 8.00039ZM9.92 8.80039H9.7125C9.1925 9.05039 8.615 9.20039 8 9.20039C7.385 9.20039 6.81 9.05039 6.2875 8.80039H6.08C4.49 8.80039 3.2 10.0904 3.2 11.6804V12.4004C3.2 13.0629 3.7375 13.6004 4.4 13.6004H11.6C12.2625 13.6004 12.8 13.0629 12.8 12.4004V11.6804C12.8 10.0904 11.51 8.80039 9.92 8.80039ZM4.3275 8.46539C4.0375 8.17789 3.64 8.00039 3.2 8.00039H1.6C0.7175 8.00039 0 8.71789 0 9.60039V10.4004C0 10.8429 0.3575 11.2004 0.8 11.2004H2.4475C2.605 10.0154 3.32 9.01789 4.3275 8.46539Z",
    fill: "#9FA2B4"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg4Contacts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/4. contacts.9ff32aae.svg";
export { ForwardRef as ReactComponent };